<template>
  <div class="group">
      <div class="group-header">
          <yxt-button v-show="!dragging" class="group-header-btn--text" type="plain" @click="toQuick">
              <!-- <img class="group-header__icon" src="../../../assets/quick.png" /> -->
              <tooltip-content center :content="$t('pc_biz_group_quick' /*快速分组*/ )">{{ $t('pc_biz_group_quick' /*快速分组*/ ) }}</tooltip-content>
          </yxt-button>
          <yxt-button v-show="!dragging" class="group-header-btn--text" drag-value="new" type="plain" @click="addEmptyGroup">
              <!-- <i class="yxt-icon-plus"></i> -->
              <tooltip-content center :content="$t('pc_biz_group_new' /*添加分组*/ )">{{ $t('pc_biz_group_new' /*添加分组*/ ) }}</tooltip-content>
          </yxt-button>
          <yxt-tooltip class="item" effect="dark" :content="$t('pc_biz_group_clear' /*重置分组*/ )" placement="top">
            <yxt-button v-show="!dragging" @click="clearGroup" class="group-header-btn--icon" icon="yxt-icon-refresh" ></yxt-button>
          </yxt-tooltip>
          <yxt-button v-show="dragging" class="group-header-add group-header-btn--full" drag-value="new" type="plain">
              <i class="yxt-icon-plus"></i>
              {{$t('pc_biz_group_add' /*新的分组*/ )}}
          </yxt-button>
      </div>
      <div class="group-content">
          <div :class="{
              'group-content-not':true,
              'group-content-not--active': !id
            }"
            drag-value="none"
            @click="setGroupId('')"
          >
              <span class="group-content-not__name">{{$t('pc_biz_group_none' /* 未分组 */ )}}</span>
              <span>{{leftMemberNum}}/{{this.memberList.length}}</span>
          </div>
          <div class="group-content-list">
            <List :group-list="groupList" :id="id" :dragging="dragging"></List>
          </div>
      </div>
  </div>
</template>

<script>
import { Button, Message } from 'yxt-pc';
import List from './group-list.vue';
import TooltipContent from './tooltip-content.vue';

export default {
  components: {
    'yxt-button': Button,
    'tooltip-content': TooltipContent,
    List
  },
  props: {
    memberList: {
      type: Array,
      require: true
    },
    groupList: {
      type: Array,
      require: true
    },
    id: {
      type: String,
      require: true
    },
    dragging: {
      type: Boolean,
      default: false
    }
  },
  inject: {
    addEmptyGroup: {
      default: () => {}
    },
    setGroupId: {
      default: ()=>{}
    },
    setPage: {
      default: () => {}
    },
    clearGroup: {
      default: () => {}
    }
  },
  computed: {
    leftMemberNum() {
      let total = this.memberList.length;
      for (let i = 0; i < this.groupList.length;i++) {
        total -= this.groupList[i].groupMemberList.length;
      }
      return total;
    }
  },
  methods: {
    toQuick() {
      if (this.leftMemberNum > 0) {
        this.setPage('Quick');
      } else {
        Message.info(this.$t('pc_biz_group_need_student_tip' /* 请先添加学员 */));
      }
    }
  }
};
</script>

<style lang="scss" scoped>
.group{
    display: flex;
    flex-direction: column;
    height: 100%;

    &-header{
        display: flex;
        align-items: center;
        justify-content: space-between;
        > i {
            width: 32px;
            height: 32px;
            background: rgba(255, 255, 255, 0.01);
            border-radius: 4px;
            border: 1px solid #D9D9D9;
            font-size: 16px;
            display: flex;
            align-items: center;
            justify-content: center;
            box-sizing: border-box;
            cursor: pointer;
        }

        &__icon{
          width: 14px;
          height: 14px;
        }

        &-btn--text{
          padding: 4px 11px;
          width: 87.5px;
        }
        &-btn--icon{
          padding: 4px 9px;
        }
        &-btn--full{
          width: 100%;
        }
        /deep/ .yxt-button{
            // width: 96px;
            // height: 32px;
            background: rgba(255, 255, 255, 0.01);
            border-radius: 4px;
            border: 1px solid #D9D9D9;
            box-sizing: border-box;
            color: #595959;
            margin-left: 0;
             i {
                font-size: 12px;
            }
        }
    }

    &-content{
        margin-top: 8px;
        flex-grow: 1;
        display: flex;
        flex-direction: column;
        height: calc(100% - 40px);

        &-not{
            height: 38px;
            border-radius: 4px;
            padding: 9px 12px;
            font-size: 14px;
            color: #595959;
            display: flex;
            align-items: center;
            justify-content: space-between;
            user-select: none;
            -ms-user-select: none;
            &:hover{
                background: #F5F5F5;
            }
        }
        &-not--active{
          background: #F0F6FF;
          .group-content-not__name{
            color: #436BFF;
          }
        }
        &-list{
            flex-grow: 1;
            height: calc(100% - 38px);
        }
    }
}
</style>>
